/* eslint-disable no-throw-literal */
import api from './';

export const login = async (credentials) => {
  try {
    const { data } = await api.post(`/api/login`, credentials, { withCredentials: true });
    return data;
  } catch (err) {
    if (err?.response?.status === 401) {
      throw { code: 'unauthorized' }
    } else if(err?.response?.status === 400 && err?.response?.data) {
      throw err.response.data;
    }
    throw { code: 'internalError' }
  }
}

export const resetPassword = async (formData, token = null) => {
  const SecurityToken = token || sessionStorage.getItem('@resetToken@');
  
  const { data } = await api.put(`/api/password/reset`, formData, {
    headers: { SecurityToken },
    withCredentials: true,
  });

  if (!token) {
    sessionStorage.removeItem('@resetToken@');
  }
  return data;
}

export const sendPasswordCode = async (formData) => {
  await api.post(`/api/password/code/send`, formData);
}

export const validatePasswordCode = async (formData, code = null) => {
  try {
    const { data } =  await api.post(`/api/password/code/validate`, { ...formData, code });
    return data;
  } catch (err) {
    if (err?.response?.status === 400) {
      throw { code: 'invalidCode' };
    }
    
    throw { code: 'internalError' }
  }
}

export const createUser = async (user) => {
  const response = await api.post(`/api/uservtex`, {"data": user} , { withCredentials: true });
  return response?.data;
};

export const logout = async () => {
  return api.get(`/api/logout`, {
    withCredentials: true,
  });
}

export const createAddress = async (form, token) => {
  const response = await api.post(`/api/v1/uservtex/address`, form, {
    headers: {
      'Content-Type': 'application/json',
      'ApplicationToken': `Bearer ${token}`,
      'store': 1,
    },
  });
  return response?.data;
};

export const getEmailsByDocument = async (document) => {
  const { data } = await api.get(`/api/emails`, {
    params: { document },
  });

  return data;
};

export const userExists = async (params) => {
  await api.get(`/api/emails/verify`, { params });
};

export const cpfExists = async (params) => {
  await api.get(`/api/cpfs/verify`, { params });
};

// Buscar orderformId por e-mail usando o backend como proxy
export const getOrderFormIdByEmail = async (email) => {
  try {
    console.log('Buscando orderFormId para o email:', email);
    
    // Atualizado para usar a nova rota
    const { data } = await api.get(`/api/orderforms/by-email`, {
      params: { email }
    });
    
    return data;
  } catch (err) {
    console.error("Erro ao buscar orderFormId por email:", err);
    
    // Se ocorrer um erro, retornar um array vazio
    // O componente de UI deve lidar com o caso de não encontrar carrinhos
    return [];
  }
};

// Buscar detalhes do orderform por ID usando o backend como proxy
export const getOrderFormDetails = async (orderFormId) => {
  try {
    console.log('Buscando detalhes para o orderForm:', orderFormId);
    
    // Atualizado para usar a nova rota
    const { data } = await api.get(`/api/orderforms/${orderFormId}`);
    
    return data;
  } catch (err) {
    console.error("Erro ao buscar detalhes do orderForm:", err);
    
    // Retornar um objeto vazio se ocorrer um erro
    // O componente de UI deve lidar com o caso de não encontrar detalhes
    throw { code: 'not_found', message: 'Carrinho não encontrado' };
  }
};

// Buscar carrinhos por e-mail
export const getCartsByEmail = async (email) => {
  try {
    // Obter o orderFormId associado ao e-mail
    const orderFormData = await getOrderFormIdByEmail(email);
    
    if (!orderFormData || orderFormData.length === 0 || !orderFormData[0].orderformId) {
      return { data: [] }; // Nenhum carrinho encontrado
    }
    
    // Para cada orderFormId encontrado, buscar os detalhes
    const carts = [];
    
    for (const item of orderFormData) {
      try {
        if (item.orderformId) {
          const details = await getOrderFormDetails(item.orderformId);
          carts.push(details);
        }
      } catch (err) {
        console.warn(`Não foi possível carregar o carrinho ${item.orderformId}:`, err);
      }
    }
    
    return { data: carts };
  } catch (err) {
    if (err?.code === 'not_found') {
      return { data: [] };
    }
    throw err.code ? err : { code: 'internalError', message: 'Erro ao buscar carrinhos' };
  }
};

// Buscar carrinhos por CPF/CNPJ
export const getCartsByDocument = async (document) => {
  try {
    // Por enquanto, pesquisamos por email para demonstração
    // No mundo real, seria necessário implementar uma busca por documento
    return await getCartsByEmail(document);
  } catch (err) {
    throw { code: 'internalError', message: err.message || 'Erro ao buscar carrinhos por documento' };
  }
};

// Buscar detalhes do carrinho
export const getCartDetails = async (orderFormId) => {
  try {
    return await getOrderFormDetails(orderFormId);
  } catch (err) {
    if (err?.code === 'not_found') {
      throw { code: 'not_found', message: 'Carrinho não encontrado' };
    }
    throw { code: 'internalError', message: err.message || 'Erro ao buscar detalhes do carrinho' };
  }
};
